import A11YSlider from "a11y-slider";

let spotlight = document.querySelector(".tinyslider-inner");

if (spotlight) {
  const slider = new A11YSlider(spotlight, {
    slidesToShow: 1,
    arrows: true, // arrows enabled 767px and down
    dots: false,
    prevArrow: document.querySelector(".tinyslider-control-prev"),
    nextArrow: document.querySelector(".tinyslider-control-next"),
    responsive: {
      768: {
        slidesToShow: 2,
      },
      980: {
        slidesToShow: 3,
      },
      1280: {
        slidesToShow: 4,
      },
      1920: {
        slidesToShow: 5,
      },
    },
  });
}

let cards = document.querySelector(".tinyslider-inner-small");

if (cards) {
  const slider = new A11YSlider(cards, {
    slidesToShow: 1,
    arrows: true, // arrows enabled 767px and down
    dots: false,
    prevArrow: document.querySelector(".tinyslider-control-prev"),
    nextArrow: document.querySelector(".tinyslider-control-next"),
    responsive: {
      768: {
        slidesToShow: 2,
      },
      980: {
        slidesToShow: 3,
      },
    },
  });
}
